import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/studio/teams/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::create
* @see Http/Controllers/Web/Studio/TeamController.php:19
* @route '/studio/teams/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::store
* @see Http/Controllers/Web/Studio/TeamController.php:24
* @route '/studio/teams'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/teams',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::store
* @see Http/Controllers/Web/Studio/TeamController.php:24
* @route '/studio/teams'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::store
* @see Http/Controllers/Web/Studio/TeamController.php:24
* @route '/studio/teams'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::store
* @see Http/Controllers/Web/Studio/TeamController.php:24
* @route '/studio/teams'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\TeamController::store
* @see Http/Controllers/Web/Studio/TeamController.php:24
* @route '/studio/teams'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const teams = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
}

export default teams